import { __decorate, __metadata } from "tslib";
import { singleton, contrib, Syringe, Contribution } from 'mana-syringe';
import { RenderingPluginContribution } from '../services/RenderingService';
export var CullingStrategyContribution = Syringe.defineToken('CullingStrategyContribution');
/**
 * apply following rules:
 * 1. `visibility` in scenegraph node
 * 2. other custom culling strategies, eg. frustum culling
 */

var CullingPlugin =
/** @class */
function () {
  function CullingPlugin() {}

  CullingPlugin_1 = CullingPlugin;

  CullingPlugin.prototype.apply = function (renderingService) {
    var strategies = this.strategyProvider.getContributions();
    renderingService.hooks.prepare.tap(CullingPlugin_1.tag, function (object) {
      if (object) {
        var cullable = object.cullable;

        if (strategies.length === 0) {
          cullable.visible = true;
        } else {
          // eg. implemented by g-webgl(frustum culling)
          cullable.visible = strategies.every(function (strategy) {
            return strategy.isVisible(object);
          });
        }

        if (object.isVisible()) {
          return object;
        }

        return null;
      }

      return object;
    });
    renderingService.hooks.afterRender.tap(CullingPlugin_1.tag, function (object) {
      object.cullable.visibilityPlaneMask = -1;
    });
  };

  var CullingPlugin_1;
  CullingPlugin.tag = 'CullingPlugin';

  __decorate([contrib(CullingStrategyContribution), __metadata("design:type", Object)], CullingPlugin.prototype, "strategyProvider", void 0);

  CullingPlugin = CullingPlugin_1 = __decorate([singleton({
    contrib: RenderingPluginContribution
  })], CullingPlugin);
  return CullingPlugin;
}();

export { CullingPlugin };